import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { CauseMarquee } from "@/components/Marquee";
import { ImpactStats } from "@/components/ImpactStats";
import { Story } from "@/components/Story";
import { Manifesto } from "@/components/Manifesto";
import { Causes } from "@/components/Causes";
import { Campaigns } from "@/components/Campaigns";
import { DonorWall } from "@/components/DonorWall";
import { Testimonials } from "@/components/Testimonials";
import { DonateSection } from "@/components/DonateSection";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { getCampaigns, getContent, getPublicSettings } from "@/lib/api";

export default function Landing() {
  const [campaigns, setCampaigns] = useState([]);
  const [selected, setSelected] = useState(null);
  const [home, setHome] = useState(null);
  const [settings, setSettings] = useState(null);
  const [mission, setMission] = useState(null);
  const [testimonials, setTestimonials] = useState(null);

  useEffect(() => {
    getCampaigns().then(setCampaigns).catch(() => {});
    getContent("home").then(setHome).catch(() => {});
    getPublicSettings().then(setSettings).catch(() => {});
    getContent("mission").then((m) => m ? setMission(m) : getContent("about").then(setMission)).catch(() => {});
    getContent("testimonials").then(setTestimonials).catch(() => {});
  }, []);

  const handleDonate = (campaign) => {
    setSelected(campaign);
    document.getElementById("donate")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main>
      <Header />
      <Hero cms={home} />
      <CauseMarquee />
      <ImpactStats stats={home?.impact_stats} />
      <Story content={mission} />
      <Manifesto />
      <Causes />
      {campaigns.length > 0 && <Campaigns campaigns={campaigns} onDonate={handleDonate} />}
      <DonorWall />
      <Testimonials content={testimonials} />
      <DonateSection campaigns={campaigns} selected={selected} donation={settings?.donation} />
      <Contact settings={settings} />
      <Footer settings={settings} />
    </main>
  );
}
